var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckFeasibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9067 30V22.0583C11.9549 22.1929 10.0032 22.6641 8.2533 23.539C9.46474 26.2984 11.4165 28.5867 13.9067 30Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09964 9.069C5.0901 8.46328 4.14787 7.72296 3.27295 6.91533C1.38848 9.2036 0.311648 12.0303 0.109741 14.9916H5.09011C5.09011 12.9725 5.42662 11.0208 6.09964 9.069Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70527 24.3466C5.89764 24.885 5.09001 25.4907 4.41699 26.1637C6.16685 27.8463 8.25322 29.0577 10.6088 29.7308C8.92624 28.2501 7.6475 26.4329 6.70527 24.3466Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0228 16.7414H0.109741C0.311648 19.7027 1.38848 22.5294 3.27295 24.8177C4.14787 24.01 5.0901 23.2697 6.09964 22.664C5.42662 20.7795 5.09011 18.7605 5.0228 16.7414Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6088 2.0695C8.25322 2.74253 6.16685 3.95397 4.41699 5.63652C5.09001 6.30954 5.89764 6.91526 6.70527 7.45368C7.6475 5.36731 8.92624 3.55015 10.6088 2.0695Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0794 6.17499C18.1467 5.43466 18.2813 4.76164 18.4832 4.02132C17.6083 3.14639 16.666 2.40606 15.6565 1.80034V9.742C16.5987 9.6747 17.6083 9.5401 18.5505 9.33819C18.214 8.26136 18.0121 7.18452 18.0794 6.17499Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8578 14.857L20.5023 12.4341C20.0311 11.963 19.6273 11.4246 19.2908 10.8862C18.0794 11.2227 16.8679 11.4246 15.6565 11.4919V14.9916H22.7905C22.8578 14.9916 22.8578 14.9243 22.8578 14.857Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8578 16.7414H15.6565V20.3084C17.8102 20.443 19.9638 20.9814 21.9156 21.8564C22.454 20.2411 22.7905 18.4913 22.8578 16.7414Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0979 18.0202C26.9633 18.2221 26.6941 18.2894 26.4922 18.2894C26.2903 18.2894 26.0211 18.2221 25.8865 18.0202L24.6077 16.6741C24.5404 18.6932 24.2039 20.7123 23.5309 22.664C24.5404 23.2698 25.4826 24.0101 26.3576 24.8177C28.4439 22.2602 29.5881 19.097 29.5881 15.7992C29.5881 15.6646 29.5881 15.53 29.5881 15.3954L27.0979 18.0202Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7805 6.10767C28.7805 4.82893 27.771 3.75209 26.4249 3.75209C25.0789 3.75209 24.0693 4.82893 24.0693 6.10767C24.0693 7.38641 25.0789 8.46325 26.4249 8.46325C27.771 8.46325 28.7805 7.38641 28.7805 6.10767Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0879 6.24228C32.9533 4.55972 32.2802 3.01177 31.0688 1.86764C28.5113 -0.622545 24.4059 -0.622545 21.8484 1.86764C20.637 3.01177 19.9639 4.55972 19.8293 6.24228C19.762 7.11721 19.8966 8.05944 20.2331 8.86706C20.5697 9.74199 21.1081 10.5496 21.7811 11.2226L26.4922 16.1357L31.2034 11.2226C31.8764 10.5496 32.4148 9.74199 32.7513 8.86706C33.0206 8.05944 33.1552 7.18451 33.0879 6.24228ZM26.4922 10.2131C24.8097 10.2131 23.329 9.20358 22.7233 7.72293C22.1176 6.24228 22.4541 4.42512 23.5983 3.28098C24.7424 2.13684 26.4922 1.73303 28.0402 2.40605C29.5881 3.01177 30.5977 4.55972 30.5977 6.17498C30.5304 8.32865 28.7132 10.2131 26.4922 10.2131Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0217 29.7308C21.31 29.0577 23.4637 27.8463 25.1462 26.1637C24.4732 25.4907 23.6656 24.885 22.858 24.3466C21.983 26.4329 20.637 28.2501 19.0217 29.7308Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64751 21.8564C9.59928 20.9141 11.7529 20.3757 13.9739 20.3084V16.7414H6.77258C6.83989 18.4913 7.10909 20.2411 7.64751 21.8564Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77258 14.9916H13.9066V11.4246C11.7529 11.29 9.59928 10.7515 7.58021 9.87661C7.10909 11.5592 6.83989 13.309 6.77258 14.9916Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2533 8.26135C10.0032 9.13628 11.9549 9.6074 13.9067 9.742V1.80034C11.4165 3.21369 9.46474 5.50196 8.2533 8.26135Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6565 22.0583V30C18.1467 28.5867 20.0984 26.3657 21.3099 23.539C19.56 22.6641 17.6756 22.1256 15.6565 22.0583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFeasibility);
export default __webpack_public_path__ + "static/media/check_feasibility.a0fb38aff4bdd9933800f50bfba88f31.svg";
export { ForwardRef as ReactComponent };